import { FileResource } from './folders.types';

export function buildCreateFileFormData(fileResource: FileResource, document: File): FormData {
  const formData = new FormData();
  Object.entries(fileResource || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(`file_resource[${key}]`, value as string);
    }
  });
  formData.append('document[attachment]', document);
  return formData;
}
